import React from 'react'

function PageNotFound() {
  return (
    <>
        <h1>Opps, 404 Page Not Found</h1>
        <a href='/'>Back to home</a>
    </>
  )
}

export default PageNotFound